import React, { FC } from 'react';
import { Modal as ReactModal, Text, View } from 'react-native';
import LinearGradientButton from '../LinearGradientButton';
import styles from './styles';

export type ModalProps = {
  messageText: string;
  modalVisible: boolean;
  onPressOverride?: () => void;
  setModalVisible: (e: boolean) => void;
};

export const Modal: FC<ModalProps> = (props) => {
  const { messageText, modalVisible, onPressOverride, setModalVisible } = props;
  const onPress = () => {
    setModalVisible(!modalVisible);
    onPressOverride && onPressOverride();
  };
  return (
    <View>
      <ReactModal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={onPress}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <Text style={styles.modalText}>{messageText}</Text>
            <LinearGradientButton onPress={onPress} title="Close" />
          </View>
        </View>
      </ReactModal>
    </View>
  );
};

export default Modal;
